import { gql } from '@apollo/client'

export const CREATE_ACTION_MUTATION = gql`
  mutation createAction($attributes: ActionInput!) {
    createAction(attributes: $attributes) {
      id
      type
      disputeValue
      processingId
      note
      visibleForPolicyholder
      visibleForOtherProcessings
      firstCall
      contactType
      informReason
      completeReason
      closingTypeId
      actualProcessingTypeId
      customerRating
      customerComments
      closingResult
      costsCoveredByKp
      costs
      contactSuccessful
      closingTypeOther
      date
      policyholderAgreesMediation
      conflictPartnerAgreesMediation
      conflictPartnerAgreesToCoverCosts
      resultId
      result {
        id
        title
        systemValue
        resultType
        parentResultId
        parentResult {
          id
          title
          systemValue
        }
      }
      uploads {
        id
        attachmentUrl
        attachmentFilename
      }
    }
  }
`
